<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Add Bin List</h2>
          </div>
          <ValidationObserver v-slot="{ passes }">
            <div class="body">
              <form @submit.prevent="passes(binSubmitData)">
                <div class="row">
                  <div class="col-sm-6 col-12">
                    <ValidationProvider
                      name="card_country"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              addbin.cardcountry &&
                              addbin.cardcountry.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="card_country">Card Country*</label>
                            <multiselect
                              placeholder=""
                              v-model="addbin.cardcountry"
                              :show-labels="false"
                              :options="countryList"
                              :searchable="true"
                              label="name"
                              track-by="countryid"
                            >
                              <template slot="option" slot-scope="props">
                                <span
                                  :class="
                                    'flag-icon flag-icon-' +
                                    props.option.isoCode.toLowerCase() +
                                    ' fi-md fi-round '
                                  "
                                ></span>
                                <div class="option__desc">
                                  <span class="option__title">
                                    {{ props.option.countryname }}
                                  </span>
                                </div>
                              </template>
                            </multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                addbin.cardcountry &&
                                addbin.cardcountry.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="bin_number"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.number,
                          success: addbin.number,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.number"
                            class="form-control"
                            id="bin_number"
                            placeholder="Bin Number*"
                          />
                          <label for="bin_number" class="control-label">
                            Bin Number*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.number"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.number"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="bank_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.bankname,
                          success: addbin.bankname,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.bankname"
                            class="form-control"
                            id="bank_name"
                            placeholder="Bin Number*"
                          />
                          <label for="bank_name" class="control-label">
                            Bank name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.bankname"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.bankname"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="addbin.number"
                          class="form-control"
                          id="bankbrand_name"
                          placeholder="bank brand name*"
                        />
                        <label for="bankbrand_name" class="control-label">
                          Bank Brand name
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <ValidationProvider
                      name="payment_gateway"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              addbin.paymentGateway &&
                              addbin.paymentGateway.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="payment_gateway">
                              Payment Gateway*
                            </label>
                            <multiselect
                              placeholder=""
                              v-model="addbin.paymentGateway"
                              :show-labels="false"
                              :options="paymentGateway_options"
                              :searchable="false"
                            ></multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                addbin.paymentGateway &&
                                addbin.paymentGateway.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-sm-6 col-12">
                    <ValidationProvider
                      name="card_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.cardtype,
                          success: addbin.cardtype,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.cardtype"
                            class="form-control"
                            id="card_type"
                            placeholder="Card Type*"
                          />
                          <label for="card_type" class="control-label">
                            Card Type*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.cardtype"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.cardtype"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="brand_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.brandname,
                          success: addbin.brandname,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.brandname"
                            class="form-control"
                            id="brand_name"
                            placeholder="Brand name*"
                          />
                          <label for="brand_name" class="control-label">
                            Brand name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.brandname"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.brandname"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="card_level1"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.cardlevel1,
                          success: addbin.cardlevel1,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.cardlevel1"
                            class="form-control"
                            id="card_level1"
                            placeholder="Card Level1*"
                          />
                          <label for="card_level1" class="control-label">
                            Card Level1*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.cardlevel1"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.cardlevel1"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="card_level2"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addbin.cardlevel2,
                          success: addbin.cardlevel2,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addbin.cardlevel2"
                            class="form-control"
                            id="card_level2"
                            placeholder="Card Level2*"
                          />
                          <label for="card_level2" class="control-label">
                            Card Level2*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addbin.cardlevel2"
                          ></i>
                          <i class="fa fa-check" v-if="addbin.cardlevel2"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="d-flex align-items-center m-b-20 mt-2">
                      <div class="custom-switch success-error-bg mr-2">
                        <input
                          type="checkbox"
                          class="custom-switch-input"
                          id="customSwitch1"
                          v-model="addbin.iswhitelisted"
                        />
                        <label class="custom-switch-label" for="customSwitch1">
                          <span class="custom-switch-text1">Yes</span>
                          <span class="custom-switch-text2">No</span>
                        </label>
                      </div>
                      <label class="mb-0" for="customSwitch1">
                        Is whitelisted?
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import { mapState, mapGetters } from "vuex";
export default {
  name: "AddPartnerComponent",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  data() {
    return {
      addbin: {
        number: "",
        bankname: "",
        bankbrandname: "",
        brandname: "",
        cardtype: "",
        cardlevel1: "",
        cardlevel2: "",
        cardcountry: "",
        paymentGateway: "",
        iswhitelisted: true,
      },
      paymentGateway_options: ["CashFlows", "Paysafe", "None"],
    };
  },
  methods: {
    binSubmitData() {
      console.log("Submited");
    },
  },
  computed: {
    ...mapGetters(["countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
